import { createShouldForwardProp, props as defaultStyledSystemProps } from '@styled-system/should-forward-prop';
export var ignorePropsForwarding = function ignorePropsForwarding() {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return createShouldForwardProp([...defaultStyledSystemProps, ...props]);
};